















































import Toolbar from "../components/toolbar/Toolbar.vue";
import CollectionFilterContainer from "@/components/ai-results/CollectionFilterContainer.vue";
import AiSearchResultsContainer from "@/components/ai-search/AiSearchResultsContainer.vue";
import { defineComponent, getCurrentInstance, ref, computed } from "@vue/composition-api";
import Infoland3colContainer from "@/components/generic/infoland-3col-container.vue";
import storeHelper from "@/store/store-helper";
import AiSearchBar from "@/components/ai-search/AiSearchBar.vue";
import { useScroll } from "@/composables/useScroll";

export default defineComponent({
    props: {
        searchText: { type: String, default: "" },
        portalId: { type: Number, required: true },
        collectionId: { type: Number, default: null },
        title: { type: String, default: "" }
    },
    components: {
        Toolbar,
        AiSearchBar,
        CollectionFilterContainer,
        AiSearchResultsContainer,
        Infoland3colContainer
    },
    setup(props) {
        const router = getCurrentInstance().proxy.$router;

        /**
         * handle the search text changed event
         */
        const onSearchTextChanged = (searchText: string) => {
            //if not searching anymore, go back to browse
            searchText.trim() == "" ? redirectToBrowseRoute() : updateSearchRoute(searchText, props.collectionId);
        };

        /**
         * updates the route and reflects the search filters in the url
         */
        const updateSearchRoute = (searchText: string, collectionId: number | null) => {
            let routeChange: any = {
                name: "AISearch",
                params: { portalId: props.portalId.toString() },
                query: {},
                replace: false
            };

            if (searchText != null) {
                routeChange.query.searchText = searchText;
            }

            if (collectionId != null) {
                routeChange.query.collectionId = collectionId;
            }

            //do not change route if you are already on the same route
            const route = router.currentRoute;
            const isSameRoute =
                route.name === routeChange.name &&
                JSON.stringify(route.params) === JSON.stringify(routeChange.params) &&
                JSON.stringify(route.query) === JSON.stringify(routeChange.query);
            if (isSameRoute) return;

            router.push(routeChange);
        };

        const redirectToBrowseRoute = () => {
            router.push({
                name: "AIBrowse",
                replace: false
            });
        };

        /**
         * handle the search results loaded event
         * so we can load relevant filters
         */
        const filterScope = computed(() => (props.collectionId == null ? "all" : "collection"));
        const visibleCollectionIds = ref<number[]>([]);
        const onSearchResultsLoaded = async (value: boolean) => {
            if (!value) return;
            visibleCollectionIds.value = storeHelper.aiSearchStore.getCollectionIds(filterScope.value);
        };

        /**
         * handle the back button navigation
         */
        const onBackNavigation = () => {
            router.go(-1);
        };

        /**
         * The direction of the scroll needed for UI animations
         */
        const { direction: scrollDirection } = useScroll({ directionChangeTreshold: 36 });
        const isScrollingUp = computed(() => scrollDirection.value === "up");

        return {
            props,
            onSearchTextChanged,
            onSearchResultsLoaded,
            onBackNavigation,
            updateSearchRoute,
            isScrollingUp,
            filterScope,
            visibleCollectionIds
        };
    }
});
